import React from 'react';

import { WLNumberBadge } from '../../design-library';
import * as Icons from '../../design-library/Icons';
import { WLIconProps } from '../../design-library/Icons/icon.props.interface';

interface IconAdapterProps extends WLIconProps {
  name: string | null | undefined;
}

const IconAdapter: React.FC<IconAdapterProps> = ({ name, ...rest }) => {
  if (!name) {
    return null;
  }

  if (Number.isInteger(parseInt(name, 10))) {
    return <WLNumberBadge iconSize={56} number={name} />;
  }

  const iconComponent = `${name}Icon`;
  const Icon = (Icons as Record<string, React.ComponentType>)[iconComponent];

  if (!Icon) {
    return null;
  }
  return <Icon {...rest} />;
};

export default IconAdapter;
